import { MerlinActionTypes } from './merlin.types';

export const initialState = {
  maiaAgent: 'general',
  loading: false,
  token: null,
  merlinUrl: null,
  isIframeOpen: false,
  chatId: null,
  chatCookieName: '',
  migrationData: {
    hostingId: null,
    domain: '',
    type: '',
  },
  chatHistory: [],
  audioTranscription: '',
  loadingTranscription: false,
  renderInHouseChat: false,
  minimizedChat: false,
  visibleAiChat: false,
  currentChat: {
    route: null,
    fullScreen: false,
    threadid: null,
  },
  sideContent: {
    isOpen: false,
    url: '',
  },
  externalMessage: '',
  externalAudioBlob: null,
  messageFromRequest: '',
  ratedMessages: [],
  executeN8nLoading: false,
  alerts: [],
  loadingAlerts: false,
  showAlerts: false,
  alertsTypes: null,
  loadingAlertsTypes: false,
  withMultiAgent: false,
  withN8n: false,
};

const merlinReducer = (state = initialState, action) => {
  switch (action.type) {
    case MerlinActionTypes.ACTION_WITH_MULTI_AGENT: {
      return {
        ...state,
        withMultiAgent: true,
        withN8n: false,
      };
    }
    case MerlinActionTypes.ACTION_WITH_N8N: {
      return {
        ...state,
        withN8n: true,
        withMultiAgent: false,
      };
    }
    case MerlinActionTypes.AI_LOADING_ALERTS_TYPES: {
      return {
        ...state,
        loadingAlertsTypes: action.payload,
      };
    }
    case MerlinActionTypes.AI_SET_ALERTS_TYPES: {
      return {
        ...state,
        alertsTypes: {
          ...state.alertsTypes,
          ...action.payload.alertsTypes,
        },
      };
    }
    case MerlinActionTypes.AI_SET_LOADING_BY_SLUG: {
      return {
        ...state,
        alertsTypes: {
          ...state.alertsTypes,
          [action.payload.slug]: {
            ...state.alertsTypes[action.payload.slug],
            loading: action.payload.loading,
          },
        },
      };
    }
    case MerlinActionTypes.AI_SHOW_ALERTS: {
      return {
        ...state,
        showAlerts: action.payload,
      };
    }
    case MerlinActionTypes.AI_LOADING_ALERTS: {
      return {
        ...state,
        loadingAlerts: action.payload,
      };
    }
    case MerlinActionTypes.AI_SET_ALERTS: {
      const { alert } = action.payload;
      const hasAlertElements = Boolean(alert.elements);
      const currentAlertPosition = state.alerts.findIndex(existingAlert => existingAlert.type.slug === alert.type.slug);
      const alertExists = currentAlertPosition !== -1;

      let newAlerts = [...state.alerts];

      if (alertExists && !hasAlertElements) {
        newAlerts = state.alerts.filter((_, index) => index !== currentAlertPosition);
      }

      if (!alertExists && hasAlertElements) {
        newAlerts = [...state.alerts, alert];
      }

      return {
        ...state,
        alerts: newAlerts,
        alertsTypes: {
          ...state.alertsTypes,
          [alert.type.slug]: {
            ...state.alertsTypes[alert.type.slug],
            loaded: true,
            loading: false,
          },
        },
      };
    }
    case MerlinActionTypes.EXECUTE_N8N_LOADING: {
      return {
        ...state,
        executeN8nLoading: action.payload,
      };
    }
    case MerlinActionTypes.AI_CHAT_RATE_MESSAGE: {
      return {
        ...state,
        ratedMessages: action.payload.ratedMessages,
      };
    }
    case MerlinActionTypes.TOGGLE_FULLSCREEN: {
      return {
        ...state,
        currentChat: {
          ...state.currentChat,
          fullScreen: action.payload ? action.payload : !state.currentChat.fullScreen,
        },
      };
    }
    case MerlinActionTypes.AICHAT_SET_CHAT_STATE: {
      return {
        ...state,
        currentChat: {
          ...state.currentChat,
          ...action.payload,
        },
      };
    }
    case MerlinActionTypes.POC_VISIBILITY_INHOUSE_CHAT: {
      return {
        ...state,
        visibleAiChat: action.payload,
      };
    }
    case MerlinActionTypes.POC_MINIMIZE_INHOUSE_CHAT: {
      return {
        ...state,
        minimizedChat: action.payload,
      };
    }
    case MerlinActionTypes.MERLIN_GENERATE_TOKEN: {
      return {
        ...state,
        loading: true,
      };
    }
    case MerlinActionTypes.MERLIN_GENERATE_TOKEN_SUCCESS: {
      return {
        ...state,
        loading: false,
        token: action.payload.token,
      };
    }
    case MerlinActionTypes.MERLIN_GENERATE_TOKEN_FAIL: {
      return {
        ...state,
        loading: false,
      };
    }
    case MerlinActionTypes.MERLIN_SET_URL: {
      return {
        ...state,
        loading: false,
        merlinUrl: action.payload.url,
      };
    }
    case MerlinActionTypes.MERLIN_SET_CHAT_DATA: {
      const { chatId, cookieName, isIframeOpen } = action.payload;
      return {
        ...state,
        chatId,
        chatCookieName: cookieName,
        isIframeOpen,
      };
    }
    case MerlinActionTypes.MERLIN_SET_MIGRATION_DATA: {
      const { hostingId, domain, type } = action.payload;
      return {
        ...state,
        migrationData: {
          ...state.migrationData,
          hostingId,
          domain,
          type,
        },
      };
    }
    case MerlinActionTypes.MERLIN_RESET: {
      return {
        ...initialState,
        token: null,
        merlinUrl: null,
        isIframeOpen: false,
        chatId: null,
        migrationData: {
          hostingId: null,
          domain: '',
          type: '',
        },
      };
    }
    case MerlinActionTypes.POC_SET_RESPONSE: {
      const newChatHistory = [...state.chatHistory];
      const isArray = typeof action.payload.response === 'object' && Array.isArray(action.payload.response);

      if (isArray) {
        action.payload.response.forEach((item) => {
          newChatHistory.push(item);
        });
      }

      if (!isArray) {
        newChatHistory.push(action.payload.response);
      }

      return {
        ...state,
        chatHistory: newChatHistory,
      };
    }
    case MerlinActionTypes.POC_RENDER_INHOUSE_CHAT: {
      if (!action.payload) {
        return {
          ...initialState,
          migrationData: { ...state.migrationData },
          alerts: state.alerts ? [...state.alerts] : [],
          alertsTypes: state.alertsTypes ? { ...state.alertsTypes } : null,
        };
      }

      return {
        ...state,
        renderInHouseChat: action.payload,
      };
    }

    case MerlinActionTypes.SET_LOADING_TRANSCRIPTION: {
      return {
        ...state,
        loadingTranscription: action.payload,
      };
    }

    case MerlinActionTypes.GET_AUDIO_TRANSCRIPTION: {
      return {
        ...state,
        audioTranscription: action.payload.result,
        loadingTranscription: false,
      };
    }

    case MerlinActionTypes.SET_TRANSCRIPTION_ERROR: {
      return {
        ...state,
        loadingTranscription: false,
      };
    }
    case MerlinActionTypes.SET_MAIA_AGENT: {
      return {
        ...state,
        maiaAgent: action.payload,
      };
    }
    case MerlinActionTypes.SET_SIDE_CONTENT: {
      return {
        ...state,
        sideContent: {
          ...state.sideContent,
          isOpen: action.payload.isOpen,
          url: action.payload.url,
        },
      };
    }
    case MerlinActionTypes.RESET_SIDE_CONTENT: {
      return {
        ...state,
        sideContent: {
          ...state.sideContent,
          isOpen: false,
          url: '',
        },
      };
    }
    case MerlinActionTypes.GENERATE_THREAD_ID: {
      const generatedThreadId = state.currentChat.threadid || `thread_${Date.now().toString()}`;

      return {
        ...state,
        currentChat: {
          ...state.currentChat,
          threadid: generatedThreadId,
        },
      };
    }
    case MerlinActionTypes.SET_EXTERNAL_MESSAGE: {
      return {
        ...state,
        externalMessage: action.payload,
      };
    }
    case MerlinActionTypes.SET_MESSAGE_FROM_REQUEST: {
      return {
        ...state,
        messageFromRequest: action.payload,
      };
    }
    case MerlinActionTypes.SET_ROUTE: {
      return {
        ...state,
        currentChat: {
          ...state.currentChat,
          route: action.payload,
        },
      };
    }
    case MerlinActionTypes.SET_EXTERNAL_AUDIO_BLOB: {
      return {
        ...state,
        externalAudioBlob: action.payload,
      };
    }
    default:
      return state;
  }
};

export default merlinReducer;
